export enum Currency {
  AED = 'aed',
  AFN = 'afn',
  ALL = 'all',
  AMD = 'amd',
  ANG = 'ang',
  AOA = 'aoa',
  ARS = 'ars',
  AUD = 'aud',
  AWG = 'awg',
  AZN = 'azn',
  BAM = 'bam',
  BBD = 'bbd',
  BDT = 'bdt',
  BGN = 'bgn',
  BIF = 'bif',
  BMD = 'bmd',
  BND = 'bnd',
  BOB = 'bob',
  BRL = 'brl',
  BSD = 'bsd',
  BWP = 'bwp',
  BZD = 'bzd',
  CAD = 'cad',
  CDF = 'cdf',
  CHF = 'chf',
  CLP = 'clp',
  CNY = 'cny',
  COP = 'cop',
  CRC = 'crc',
  CVE = 'cve',
  CZK = 'czk',
  DJF = 'djf',
  DKK = 'dkk',
  DOP = 'dop',
  DZD = 'dzd',
  EEK = 'eek',
  EGP = 'egp',
  ETB = 'etb',
  EUR = 'eur',
  FJD = 'fjd',
  FKP = 'fkp',
  GBP = 'gbp',
  GEL = 'gel',
  GIP = 'gip',
  GMD = 'gmd',
  GNF = 'gnf',
  GTQ = 'gtq',
  GYD = 'gyd',
  HKD = 'hkd',
  HNL = 'hnl',
  HRK = 'hrk',
  HTG = 'htg',
  HUF = 'huf',
  IDR = 'idr',
  ILS = 'ils',
  INR = 'inr',
  ISK = 'isk',
  JMD = 'jmd',
  JPY = 'jpy',
  KES = 'kes',
  KGS = 'kgs',
  KHR = 'khr',
  KMF = 'kmf',
  KRW = 'krw',
  KYD = 'kyd',
  KZT = 'kzt',
  LAK = 'lak',
  LBP = 'lbp',
  LKR = 'lkr',
  LRD = 'lrd',
  LSL = 'lsl',
  LTL = 'ltl',
  LVL = 'lvl',
  MAD = 'mad',
  MDL = 'mdl',
  MGA = 'mga',
  MKD = 'mkd',
  MNT = 'mnt',
  MOP = 'mop',
  MRO = 'mro',
  MUR = 'mur',
  MVR = 'mvr',
  MWK = 'mwk',
  MXN = 'mxn',
  MYR = 'myr',
  MZN = 'mzn',
  NAD = 'nad',
  NGN = 'ngn',
  NIO = 'nio',
  NOK = 'nok',
  NPR = 'npr',
  NZD = 'nzd',
  PAB = 'pab',
  PEN = 'pen',
  PGK = 'pgk',
  PHP = 'php',
  PKR = 'pkr',
  PLN = 'pln',
  PYG = 'pyg',
  QAR = 'qar',
  RON = 'ron',
  RSD = 'rsd',
  RUB = 'rub',
  RWF = 'rwf',
  SAR = 'sar',
  SBD = 'sbd',
  SCR = 'scr',
  SEK = 'sek',
  SGD = 'sgd',
  SHP = 'shp',
  SLL = 'sll',
  SOS = 'sos',
  SRD = 'srd',
  STD = 'std',
  SVC = 'svc',
  SZL = 'szl',
  THB = 'thb',
  TJS = 'tjs',
  TOP = 'top',
  TRY = 'try',
  TTD = 'ttd',
  TWD = 'twd',
  TZS = 'tzs',
  UAH = 'uah',
  UGX = 'ugx',
  USD = 'usd',
  UYU = 'uyu',
  UZS = 'uzs',
  VEF = 'vef',
  VND = 'vnd',
  VUV = 'vuv',
  WST = 'wst',
  XAF = 'xaf',
  XCD = 'xcd',
  XOF = 'xof',
  XPF = 'xpf',
  YER = 'yer',
  ZAR = 'zar',
  ZMW = 'zmw',
}

export const CurrencySymbols: Record<Currency, string> = {
  [Currency.AED]: 'د.إ',
  [Currency.AFN]: '؋',
  [Currency.ALL]: 'L',
  [Currency.AMD]: '֏',
  [Currency.ANG]: 'ƒ',
  [Currency.AOA]: 'Kz',
  [Currency.ARS]: '$',
  [Currency.AUD]: '$',
  [Currency.AWG]: 'ƒ',
  [Currency.AZN]: '₼',
  [Currency.BAM]: 'KM',
  [Currency.BBD]: '$',
  [Currency.BDT]: '৳',
  [Currency.BGN]: 'лв',
  [Currency.BIF]: 'FBu',
  [Currency.BMD]: '$',
  [Currency.BND]: '$',
  [Currency.BOB]: 'Bs.',
  [Currency.BRL]: 'R$',
  [Currency.BSD]: '$',
  [Currency.BWP]: 'P',
  [Currency.BZD]: '$',
  [Currency.CAD]: '$',
  [Currency.CDF]: 'FC',
  [Currency.CHF]: 'CHF',
  [Currency.CLP]: '$',
  [Currency.CNY]: '¥',
  [Currency.COP]: '$',
  [Currency.CRC]: '₡',
  [Currency.CVE]: '$',
  [Currency.CZK]: 'Kč',
  [Currency.DJF]: 'Fdj',
  [Currency.DKK]: 'kr',
  [Currency.DOP]: 'RD$',
  [Currency.DZD]: 'د.ج',
  [Currency.EEK]: 'kr',
  [Currency.EGP]: '£',
  [Currency.ETB]: 'Br',
  [Currency.EUR]: '€',
  [Currency.FJD]: '$',
  [Currency.FKP]: '£',
  [Currency.GBP]: '£',
  [Currency.GEL]: '₾',
  [Currency.GIP]: '£',
  [Currency.GMD]: 'D',
  [Currency.GNF]: 'FG',
  [Currency.GTQ]: 'Q',
  [Currency.GYD]: '$',
  [Currency.HKD]: '$',
  [Currency.HNL]: 'L',
  [Currency.HRK]: 'kn',
  [Currency.HTG]: 'G',
  [Currency.HUF]: 'Ft',
  [Currency.IDR]: 'Rp',
  [Currency.ILS]: '₪',
  [Currency.INR]: '₹',
  [Currency.ISK]: 'kr',
  [Currency.JMD]: '$',
  [Currency.JPY]: '¥',
  [Currency.KES]: 'KSh',
  [Currency.KGS]: 'с',
  [Currency.KHR]: '៛',
  [Currency.KMF]: 'CF',
  [Currency.KRW]: '₩',
  [Currency.KYD]: '$',
  [Currency.KZT]: '₸',
  [Currency.LAK]: '₭',
  [Currency.LBP]: 'ل.ل',
  [Currency.LKR]: 'Rs',
  [Currency.LRD]: '$',
  [Currency.LSL]: 'L',
  [Currency.LTL]: 'Lt',
  [Currency.LVL]: 'Ls',
  [Currency.MAD]: 'د.م.',
  [Currency.MDL]: 'L',
  [Currency.MGA]: 'Ar',
  [Currency.MKD]: 'ден',
  [Currency.MNT]: '₮',
  [Currency.MOP]: 'P',
  [Currency.MRO]: 'UM',
  [Currency.MUR]: '₨',
  [Currency.MVR]: 'Rf',
  [Currency.MWK]: 'MK',
  [Currency.MXN]: '$',
  [Currency.MYR]: 'RM',
  [Currency.MZN]: 'MT',
  [Currency.NAD]: '$',
  [Currency.NGN]: '₦',
  [Currency.NIO]: 'C$',
  [Currency.NOK]: 'kr',
  [Currency.NPR]: '₨',
  [Currency.NZD]: '$',
  [Currency.PAB]: 'B/.',
  [Currency.PEN]: 'S/',
  [Currency.PGK]: 'K',
  [Currency.PHP]: '₱',
  [Currency.PKR]: '₨',
  [Currency.PLN]: 'zł',
  [Currency.PYG]: '₲',
  [Currency.QAR]: 'ر.ق',
  [Currency.RON]: 'lei',
  [Currency.RSD]: 'дин.',
  [Currency.RUB]: '₽',
  [Currency.RWF]: 'FRw',
  [Currency.SAR]: 'ر.س',
  [Currency.SBD]: '$',
  [Currency.SCR]: '₨',
  [Currency.SEK]: 'kr',
  [Currency.SGD]: '$',
  [Currency.SHP]: '£',
  [Currency.SLL]: 'Le',
  [Currency.SOS]: 'S',
  [Currency.SRD]: '$',
  [Currency.STD]: 'Db',
  [Currency.SVC]: '$',
  [Currency.SZL]: 'L',
  [Currency.THB]: '฿',
  [Currency.TJS]: 'ЅМ',
  [Currency.TOP]: 'T$',
  [Currency.TRY]: '₺',
  [Currency.TTD]: '$',
  [Currency.TWD]: 'NT$',
  [Currency.TZS]: 'TSh',
  [Currency.UAH]: '₴',
  [Currency.UGX]: 'USh',
  [Currency.USD]: '$',
  [Currency.UYU]: '$U',
  [Currency.UZS]: 'soʻm',
  [Currency.VEF]: 'Bs.F',
  [Currency.VND]: '₫',
  [Currency.VUV]: 'VT',
  [Currency.WST]: 'WS$',
  [Currency.XAF]: 'FCFA',
  [Currency.XCD]: '$',
  [Currency.XOF]: 'CFA',
  [Currency.XPF]: '₣',
  [Currency.YER]: '﷼',
  [Currency.ZAR]: 'R',
  [Currency.ZMW]: 'ZK',
};
